module.exports = __webpack_public_path__ + "img/LogoDashboard-10.465945f1.svg";